import { createAsyncThunk } from '@reduxjs/toolkit';
import getData from '../../../api/getData';

// get all statistics admin
export const getStatistics = createAsyncThunk('statistic/statistics', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const res = await getData(`/api/admin/statistics`);
    return res;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
// get all  Chart admin
export const getChart = createAsyncThunk('statistic/getChart', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const res = await getData(`/api/admin/chart`);
    return res;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// get all statistics super admin
export const getStatisticsSuper = createAsyncThunk('statistic/getStatisticsSuper', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const res = await getData(`/api/admin/statistics-super`);
    return res;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});
